// extracted by mini-css-extract-plugin
export default {"center-dialog":"DialogContent_center-dialog__xfRcy"};